import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import BrowserLanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

/**
 * This is the list of namespaces that will be used in the app.
 * Don't manually modify this array. It will be automatically updated by the `sync-locale-namespaces.mjs` script.
 */

// eslint-disable-next-line camelcase
const $ns_UPDATED_BY_SCRIPT = [
  'account',
  'activation',
  'analytic',
  'billing',
  'chart',
  'common',
  'connectedApps',
  'dashboard',
  'datasources',
  'destination',
  'login',
  'onboarding',
  'pricing',
  'profile',
  'reporting',
  'signup',
  'team',
  'workspace',
];

/**
 * Initialize i18next
 */
i18next
  .use(initReactI18next)
  .use(BrowserLanguageDetector)
  .use(HttpBackend)
  .init({
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: $ns_UPDATED_BY_SCRIPT,
  });

export default i18next;
